import { useLocale, useT } from "react-polyglot-hooks"
import styled from "styled-components"
import Typography from "components/styled/Typography"
import { SectionContainer, TitleWrapper } from "components/styled/Grid"
import { ElDiario, ElMundo, Expansion, LaVanguardia } from "components/icons/press"

const List = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 35px 25px;

  @media ${({ theme }) => theme.breakpoints.sm} {
    grid-template-columns: repeat(4, 1fr);
    gap: 35px;
  }

  @media ${({ theme }) => theme.breakpoints.md} {
    gap: 75px;
  }
`

const Item = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 25px;

  svg {
    width: 100%;
    height: auto;
    max-width: 100%;
    max-height: 30px;
  }
`

export default function Press() {
  const t = useT()
  const locale = useLocale()

  if (locale !== "es") return null

  return (
    <SectionContainer top={25} bottom={25}>
      <TitleWrapper>
        <Typography variant="title2" weight="medium" center space el="p">
          {t("common.press")}
        </Typography>
      </TitleWrapper>
      <List>
        <Item>
          <ElMundo />
        </Item>
        <Item>
          <ElDiario />
        </Item>
        <Item>
          <Expansion />
        </Item>
        <Item>
          <LaVanguardia />
        </Item>
      </List>
    </SectionContainer>
  )
}
